import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import ListItemIcon from '@glass/web/components/base/ListItemIcon';
import ListItemText from '@glass/web/components/base/ListItemText';
import MenuItem from '@glass/web/components/base/MenuItem';

const IconMenuItem = forwardRef(
  ({ title, icon, disabled, component, params, onClick, href }, ref) => (
    <MenuItem
      ref={ref}
      component={component}
      disabled={disabled}
      href={href}
      params={params}
      onClick={onClick}
    >
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText>{title}</ListItemText>
    </MenuItem>
  ),
);

IconMenuItem.propTypes = {
  component: PropTypes.elementType,
  disabled: PropTypes.bool,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.node,
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object,
  title: PropTypes.string.isRequired,
};

export default IconMenuItem;
